import React, { Children } from "react";
import { FormField } from "admin-on-rest";
import IconHelp from "material-ui/svg-icons/action/help-outline";
import { iconStyles } from "../styles";
import { red500 } from "material-ui/styles/colors";
// import { checkSources } from '../defaultValues';

export const renderItemField = (input, record, resource, basePath) => {
  return (
    <div
      key={input.props.source}
      className={`aor-input-${input.props.source}`}
      style={input.props.style}
    >
      <FormField
        input={input}
        resource={resource}
        record={record}
        basePath={basePath}
      />
      {input.props.source === "discount" && (
        <span data-tip="" data-for="discounttooltip">
          <IconHelp style={iconStyles} color={red500} />
        </span>
      )}
    </div>
  );
};

export const renderCategory = (
  input,
  record,
  resource,
  basePath,
  categoryName
) => (
  <div>
    <div
      key={input.props.source}
      className={`aor-input-${input.props.source}`}
      style={{ display: "none" }}
    >
      <FormField
        input={input}
        resource={resource}
        record={record}
        basePath={basePath}
      />
    </div>
    <div className="label-title">Category</div>
    <div>{categoryName}</div>
  </div>
);

export const renderMainItemForm = (
  children,
  record,
  resource,
  basePath,
  categoryName
) => {
  return Children.map(
    children,
    input =>
      input &&
      (input.props.source !== "category_id"
        ? renderItemField(input, record, resource, basePath)
        : renderCategory(input, record, resource, basePath, categoryName))
  );
};

// const renderMainItemFormOld = (children, record, resource, basePath, categoryName) => {
//   console.log(children);
//   return(
//     Children.map(
//       children,
//       input => input && (
//       (checkSources(input.props,'active')
//       || checkSources(input.props,'account_id')
//       || checkSources(input.props,'name')
//       || checkSources(input.props,'slug')
//       || checkSources(input.props,'photos')
//       || checkSources(input.props,'description')
//       || checkSources(input.props,'category_id'))
//        && (input.props.source !== "category_id"
//       ? renderItemField(input, record, resource, basePath)
//       : renderCategory(input, record, resource, basePath, categoryName))
//     ))
//   )
// };



// WEBPACK FOOTER //
// ./src/products/edit/FormProductField.js